import { useToggable } from '@/utils'
import { useEffect } from 'react'

interface Props {
  delay: number
  children: React.ReactNode
  renderIfNotComplete?: React.ReactNode
}

export const WithTimeoutRendering = ({
  delay,
  children,
  renderIfNotComplete = null,
}: Props) => {
  const [show, , negate] = useToggable(undefined)

  useEffect(() => {
    const delayTimeout = setTimeout(() => {
      negate()
    }, delay)

    return () => clearTimeout(delayTimeout)
  }, [delay])

  if (!show) return renderIfNotComplete

  return children
}
